/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Center_LeftInputs */



/**
* | output |
* | --- |
* | "Center Left" |
*
* @param {Input_Position_Center_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_center_left = /** @type {((inputs?: Input_Position_Center_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Center_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro Izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央左")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro Esquerdo")
	return /** @type {LocalizedString} */ ("Center Left")
});